import { render, staticRenderFns } from "./LinkQR017.vue?vue&type=template&id=3845daaa&scoped=true&"
import script from "./LinkQR017.vue?vue&type=script&lang=js&"
export * from "./LinkQR017.vue?vue&type=script&lang=js&"
import style0 from "./LinkQR017.vue?vue&type=style&index=0&id=3845daaa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3845daaa",
  null
  
)

export default component.exports